import PropTypes from 'prop-types';
import React from 'react';

import AddOutlineIcon from '../../../../../static/icons/ic_add_2px_24.svg';
import { createBEM } from '../../../../lib/utils/css';
import Icon from '../../../Icon/Icon';

import './RowItemPlusIcon.scss';

const RowItemPlusIcon = React.memo(({ isInteractive, isImgCircle }) => {
  if (!isInteractive) {
    return null;
  }

  const classNames = createBEM('RowItemPlusIcon', {
    circle: isImgCircle,
  });

  return (
    <div className={classNames}>
      <Icon className='iconLeftColPlus' glyph={AddOutlineIcon} />
    </div>
  );
});

RowItemPlusIcon.propTypes = {
  isImgCircle: PropTypes.bool,
  isInteractive: PropTypes.bool,
};

export default RowItemPlusIcon;
